import { Widget } from './form-widget.model';
import { BooleanValueProperty } from './properties/boolean-property.model';
import { DropdownProperties } from './properties/dropdown-property.model';
import { TextProperty } from './properties/text-property.model';

export class FbDropdownWidget extends Widget {
  constructor(data: any = {}) {
    super(data);
    this.title = 'Dropdown';
    this.name = 'fb-dropdown';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any) {
    if (Array.isArray(props)) {
      const oldProperties = props;

      const labelProp = new TextProperty({ title: 'Header' });
      const contentProp = new TextProperty({ title: 'Content' });
      const required = new BooleanValueProperty({ title: 'Required' });
      const optionsProp = props.map((item) => {
        const valueProperty = new TextProperty(item.value);
        if (!valueProperty.value) {
          valueProperty.value = null;
        }
        return {
          text: new TextProperty(item.text || { title: 'Question' }),
          placeholder: new TextProperty(item.placeholder),
          value: valueProperty,
          hint: new TextProperty(item.hint || { title: 'Hint' }),
          items: new DropdownProperties(item.items),
        };
      });

      props = {
        text: labelProp,
        content: contentProp,
        columns: optionsProp,
        required: required,
      };
    }
    return props;
  }

  isValid() {
    if (!this.isRequired()) {
      return true;
    }
    return this.properties?.columns.filter((prop) => !prop.value.value)?.length === 0;
  }
}
